module.exports = __webpack_public_path__ + "img/tc-13.afea3822.png";